'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import React, { useState } from 'react';
import * as Features from 'self-service-api/constants/Features';
import { ENTERPRISE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { MARKETING, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import MON570FeatureCard from './MON570FeatureCard';
import { AsyncMon491FeatureModal } from './MON491FeatureModal';
import partial from 'transmute/partial';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useSelector } from 'react-redux';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { isMon569VariantSelector } from '../../selectors/ExperimentTreatmentSelectors';
const productLineLevelToFeatureMap = {
  [MARKETING]: {
    [PROFESSIONAL]: Features.SOCIAL_MEDIA
  },
  [SALES]: {
    [PROFESSIONAL]: Features.SEQUENCES,
    [ENTERPRISE]: Features.PLAYBOOKS
  },
  [SERVICE]: {
    [ENTERPRISE]: Features.PLAYBOOKS
  }
};
const FlexWrapper = styled(UIFlex).withConfig({
  displayName: "MON570FeatureCardWrapper__FlexWrapper",
  componentId: "evmfwa-0"
})(["width:100%;", ";", ";", ";"], breakpoint.sd(_t || (_t = _`
    flex-direction: column;
    align-items: unset;
  `)), breakpoint.tablet(_t2 || (_t2 = _`
    width: 80%;
    margin: auto
  `)), breakpoint.phone(_t3 || (_t3 = _`
    width: 90%;
  `)));

const MON570FeatureCardWrapper = ({
  productLine
}) => {
  const [featureToExpand, setFeatureToExpand] = useState(null);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isMon569Variant = useSelector(isMon569VariantSelector);
  if (!hasPricingAndPurchasingSucceeded) return null;
  const featureMap = productLineLevelToFeatureMap[productLine];
  const productLevels = Object.keys(featureMap);

  const onLearnClick = feature => {
    getUsageTracker().track('clickToViewModal', {
      name: 'feature-modal',
      feature
    });
    setFeatureToExpand(feature);
  };

  const compact = productLevels.length === 1;
  return /*#__PURE__*/_jsx(FlexWrapper, {
    isMon569Variant: isMon569Variant,
    children: productLevels.map((productLevel, productLevelIndex) => {
      const feature = featureMap[productLevel];
      const isLastCard = productLevelIndex === productLevels.length - 1;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(MON570FeatureCard, {
          className: `${isLastCard ? undefined : 'm-right-3'}`,
          feature: feature,
          productLine: productLine,
          productLevel: productLevel,
          onClick: partial(onLearnClick, feature),
          compact: compact
        }), featureToExpand === feature && /*#__PURE__*/_jsx(AsyncMon491FeatureModal, {
          productLevel: productLevel,
          productLine: productLine,
          feature: featureToExpand,
          onClose: partial(setFeatureToExpand, null)
        })]
      }, feature);
    })
  });
};

export default MON570FeatureCardWrapper;